import { combineReducers } from 'redux';
import user from './user.reducer';
import categories from './categories.reducer';
import comments from './article.comments.reducer';
import articles from './articles.reducer';
import events from './article.events.reducer';

export default combineReducers({
  user,
  categories,
  comments,
  articles,
  events,
});
